<div class="row">
    <div class="col-12">
        <h2 class="current-time">{{date | date:'h:mm:ss a'}}</h2>
    </div>
</div>